import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import H7 from 'UIComponents/elements/headings/H7';
import Small from 'UIComponents/elements/Small';
import UIChangeArrow from 'UIComponents/icon/icons/UIChangeArrow';
import UIWell from 'UIComponents/well/UIWell';
import UIWellHelpText from 'UIComponents/well/UIWellHelpText';
import UIWellItem from 'UIComponents/well/UIWellItem';
import { GOAL_TYPE_FORMAT_CONFIG } from '../../../../config/goalTypeFormatConfig';
import { GOAL_KPI_TRACKING_METHOD } from '../../../../constants/goals';
import { getIsAverageTimeBasedGoal } from '../../../../utils/goal';
import { HorizontalFlipItem } from '../../../../utils/styles';
export default function KpiProgress({
  goalTarget
}) {
  const {
    goalType,
    kpiValue,
    goalTargetAmount
  } = goalTarget;
  const goalTypeFormatConfig = GOAL_TYPE_FORMAT_CONFIG(goalTarget);
  const currentGoalValue = Number(kpiValue.toFixed(2));
  const goalTargetValue = Number(typeof goalTargetAmount !== 'string' ? goalTargetAmount.toFixed(2) : goalTargetAmount);
  const goalTargetDifference = Math.abs(currentGoalValue - goalTargetValue);
  const goalTrackingMethod = getIsAverageTimeBasedGoal(goalType) ? GOAL_KPI_TRACKING_METHOD.LOWER_IS_BETTER : GOAL_KPI_TRACKING_METHOD.HIGHER_IS_BETTER;
  const progressType = useMemo(() => {
    const targetDiff = currentGoalValue - goalTargetValue;

    if (goalTrackingMethod === GOAL_KPI_TRACKING_METHOD.HIGHER_IS_BETTER) {
      return targetDiff >= 0 ? 'increase' : 'decrease';
    } else {
      return targetDiff <= 0 ? 'increase' : 'decrease';
    }
  }, [currentGoalValue, goalTargetValue, goalTrackingMethod]);
  const isArrowFlipped = goalTrackingMethod === GOAL_KPI_TRACKING_METHOD.LOWER_IS_BETTER;
  return /*#__PURE__*/_jsx(UIWell, {
    className: "m-all-0 p-all-0",
    children: /*#__PURE__*/_jsxs(UIWellItem, {
      className: "m-all-0 p-all-0",
      children: [/*#__PURE__*/_jsx(H7, {
        className: "m-all-1 text-left",
        children: goalTypeFormatConfig[goalTarget.goalType].formatTargetAmount(Number(currentGoalValue))
      }), /*#__PURE__*/_jsxs(UIWellHelpText, {
        className: "text-left",
        children: [!isArrowFlipped && /*#__PURE__*/_jsx(UIChangeArrow, {
          size: 10,
          use: progressType
        }), isArrowFlipped && /*#__PURE__*/_jsx(HorizontalFlipItem, {
          children: /*#__PURE__*/_jsx(UIChangeArrow, {
            size: 10,
            use: progressType
          })
        }), /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: goalTypeFormatConfig[goalTarget.goalType].formatTargetAmount(goalTargetDifference)
        })]
      })]
    })
  });
}